import { Box } from '@chakra-ui/react';

interface TexasDrawerBodyProps {
  children: React.ReactNode;
}

export function TexasDrawerBody(props: TexasDrawerBodyProps) {
  return <Box padding={4}>{props.children}</Box>;
}
